export enum DisplayLayoutEnum {
   LIST = 'list',
   GRID = 'grid',
}
